module.exports = __webpack_public_path__ + "img/H5_7.7c628b28.png";